import Styles from "./header.less"
import xiaoKImg from "../image/xiaoK.png"
import question from "../image/question.png"
import centered from "../image/centered.png"
import max from "../image/max.png"
import exit from "../image/exit.png"
import React, {useRef, useState} from "react"
import classNames from "classnames"
import {Icon} from "../Icon/icon"

export interface HeaderProps {
    isFullScreen?: boolean
    onExit: () => void
    onResetSession: () => void
    onWeltClick: () => void
}

export const Header: React.FC<HeaderProps> = (props) => {
    const getSwitchIcon = () => {
        return props.isFullScreen === true ? centered : max
    }

    const getSwitchMessage = () => {
        return props.isFullScreen === true ? "窗口变小，对话时可同时操作单据" : "窗口最大，此时仅支持对话"
    }

    return (
        <header className={Styles["header"]}>
            <img src={xiaoKImg} />
            <div className={Styles["header_right"]}>
                <Icon imgSrc={getSwitchIcon()} onClick={props.onWeltClick} tipsMessage={getSwitchMessage()} />
                <Icon imgSrc={question} onClick={props.onResetSession} tipsMessage={"点击可以查看小K使用引导"} />
                <Icon imgSrc={exit} onClick={props.onExit} />
            </div>
        </header>
    )
}
